/*
* Project: LegalPlace assistant
* File: src/components/buy/pack_choice.js
* Author: Amine Azizi
* Version: 1.0
*/

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ckUpdatePack, ceTogglePack } from '../../redux/actions/checkout_operations';
import {
  lpPattern, P_SELECT_PACK_1, P_SELECT_PACK_2, P_SELECT_PACK_3,
} from '../../tracking/pattern_detector';
import lpevents from '../../tracking/lpevents';
import lpApp from '../../app/lp_app';

import TwoColumnsPack from './table-checkouts/twoColumnsPack';
import OneColumnPack from './table-checkouts/oneColumnPack.js';
import ThreeColumnsPack from './table-checkouts/threeColumnsPack';
import PackSelectorPage from './table-checkouts/PackSelectorPage';

/**
 * @description The component that selects the packs of prices.
 */
class _CePackChoiceOne extends Component {
  constructor(props) {
    super(props);
    this.onChoose = this.onChoose.bind(this);
  }

  componentWillMount() {
    document.body.classList.remove('ce-checkout');
    document.body.classList.remove('ce-checkout-s2');
    document.body.classList.remove('ce_payement_v3');
    document.body.classList.add('ce_checkout_v3');
    document.body.classList.add('ce_pricing_v3');
    document.body.classList.add('ce_checkout_sas');
    document.body.id = 'ce_v3';
  }

  componentDidMount() {
    const eventParams = {};
    eventParams['Reached Checkout'] = 'Reached Checkout';
    eventParams['checkoutVersion'] = 'legacy'
    if (!window.executeEventOnetime){
      lpevents.track('Reached Checkout', eventParams);
      // lpevents.trigger('heatmap_checkout');
      window.executeEventOnetime = 1
      lpevents.adwordsConversion({
        google_conversion_value: 0.01,
      });
    }

    //hotjar trigger

    // if (window.checkout_step !== 'paiement') {
      // should it be here???
      // writeHistory('payment', null, 'payment');
    // }

    window.checkout_step = 'paiement';
  }

  componentWillUnmount() {
    document.body.classList.remove('ce_checkout_v3');
    document.body.classList.remove('ce_pricing_v3');
    document.body.classList.remove('ce_checkout_sas');
  }

  onChoose(e) {
    const chosenPack = +(e.target.attributes['data-pack'].value);
    if (chosenPack === '1') this.props.selectOne();
    else if (chosenPack === '2') this.props.selectTwo();
    else this.props.selectThree();
    this.props.togglePack(true);
  }

  render() {
    switch (lpApp.contractMetaId) {
      /*
             * Checkout SAS
             */
      case 175:
        return <PackSelectorPage /> ;

        /*
             * Checkout SASU
             */
      case 176:
        return <PackSelectorPage />;

        /*
             * Checkout SARL
             */
      case 197:
        return <PackSelectorPage />

        /*
             * Checkout EURL
             */
      case 198:
        return <PackSelectorPage />
        /*
             * Checkout SCI
             */
      case 124:
        return <PackSelectorPage />

      /*
       * Checkout Rupture
       */
      case 184:
          return <ThreeColumnsPack />;

      /*
      * CSE moins de 20
      */
      case 229:
          return <OneColumnPack />;

      /*
      * CSE plus de 20
      */
      case 230:
          return <TwoColumnsPack removeReassurance={true} shouldNotHaveMostPopularPack={true} />;

      /*
      * CSE moins de 20 candidats
      */
      case 231:
          return <TwoColumnsPack removeReassurance={true} shouldNotHaveMostPopularPack={true} />;

      /*
       * Checkout Radiation AE
       */
      case 219:
          return <TwoColumnsPack />;

      /*
       * Checkout Auto-Entrepreneur
       */
      case 181:
          return <PackSelectorPage />

      /*
       * Checkout Auto-Entrepreneur Artisan
       */
      case 680:
          return <PackSelectorPage />

      /**
      |--------------------------------------------------
      | Changement de siège social
      |--------------------------------------------------
      */
      case 227:
        return <TwoColumnsPack removeReassurance={true} />;

      /**
      |--------------------------------------------------
      | changement-denomination-sociale
      |--------------------------------------------------
      */
     case 287:
      return <TwoColumnsPack removeReassurance={true} />;

      /**
      |--------------------------------------------------
      | modifier-date-cloture-ex-social
      |--------------------------------------------------
      */

      /**
      |--------------------------------------------------
      | Changement de siège social
      |--------------------------------------------------
      */
     case 296:
      return <TwoColumnsPack removeReassurance={true} />;

     case 301:
      return <TwoColumnsPack removeReassurance={true} />;

      /**
      |--------------------------------------------------
      | Changement de siège social EXT
      |--------------------------------------------------
      */
     case 616:
      return <TwoColumnsPack removeReassurance={true} />;

        /*
             * Checkout Association
             */
      case 162:
          return  <PackSelectorPage />;
      default:
        return <TwoColumnsPack />;
    }
  }
}

const mapStateToProps = state => ({
  first_price: state.checkout_operations.prices.first_price,
  second_price: state.checkout_operations.prices.second_price,
  third_price: state.checkout_operations.prices.third_price,
  chosen_pack: state.checkout_operations.pack,
  pricing_loading: state.loading_details.pricing,
  promo_percentage: state.checkout_operations.promo_percentage,
  title: state.contract.name,
});

const mapDispatchToProps = dispatch => ({
  togglePack: (val) => {
    dispatch(ceTogglePack(val));
  },
  selectOne: () => {
    dispatch(ckUpdatePack(0));
    lpPattern.trackInPayment(P_SELECT_PACK_1);
  },
  selectTwo: () => {
    dispatch(ckUpdatePack(1));
    lpPattern.trackInPayment(P_SELECT_PACK_2);
  },
  selectThree: () => {
    dispatch(ckUpdatePack(2));
    lpPattern.trackInPayment(P_SELECT_PACK_3);
  },
});

const CePackChoiceOne = connect(mapStateToProps, mapDispatchToProps)(_CePackChoiceOne);

export default CePackChoiceOne;



// WEBPACK FOOTER //
// ./src/components/buy/ce-checkout-step-one.js